import Rete from 'rete'

import CONST_SOCKET from '../../const/socket'
import lingualName from '../../const/lingualName'
import CONST_COMPONENT from '../../const/component'
import QuickReplyTemplate from './QuickReplyTemplate'
import { lang } from '../../assets/lang'

export default class QuickReplyComponent extends Rete.Component {
  constructor(config) {
    super(CONST_COMPONENT.QUICK_REPLY)

    this.data.component = QuickReplyTemplate
    this.socket = config ? config.sockets : null
  }

  builder (node) {
    node.lingualName = lingualName.QUICK_REPLY
    this.setConnection()

    const quickReplyInput = new Rete.Input(CONST_SOCKET.QUICK_REPLY_INPUT, lang.quick_reply_socket_input_reply, this.socket.quickReplyInput, false)
    const quickReplyOutput = new Rete.Output(CONST_SOCKET.QUICK_REPLY_OUTPUT, lang.quick_reply_socket_output_new_postback, this.socket.quickReplyOutput, false)

    return node
      .addInput(quickReplyInput)
      .addOutput(quickReplyOutput)
  }

  // eslint-disable-next-line
  worker (node, inputs, outputs) {
    outputs[CONST_SOCKET.QUICK_REPLY_OUTPUT] = node.data
  }

  setConnection() {
    // QuickReply may take connections from:
    this.socket.quickReplyInput.combineWith(this.socket.textOutputQuickreply)
    this.socket.quickReplyInput.combineWith(this.socket.carouselOutputQuickreply)
    this.socket.quickReplyInput.combineWith(this.socket.facebookMediaOutputQuickreply)
    this.socket.quickReplyInput.combineWith(this.socket.imageOutputQuickreply)
    this.socket.quickReplyInput.combineWith(this.socket.videoOutputQuickreply)
    this.socket.quickReplyInput.combineWith(this.socket.audioOutputQuickreply)
    this.socket.quickReplyInput.combineWith(this.socket.fileOutputQuickreply)
    this.socket.quickReplyInput.combineWith(this.socket.ecommerceOutputQuickreply)
    this.socket.quickReplyInput.combineWith(this.socket.genericTemplateOutputQuickreply)

    // QuickReply may be connected to:
    this.socket.quickReplyOutput.combineWith(this.socket.newPostbackInput)
  }
}